// Keep frequency ids in sync with AUTOMATION_SCHEDULE_FREQUENCIES in automation_actions.py.
const buildFrequencyCronBuilders = ({ day, day_of_week, hour, minute }) => {
    const minuteDefault = minute?.[0]?.id;
    const hourDefault = hour?.[0]?.id;
    const dayDefault = day?.[0]?.id;
    const dayOfWeekDefault = day_of_week?.[0]?.id;
    return {
        daily: {
            options: [{ index: 1, name: 'hour', values: hour }],
            default: [minuteDefault, hourDefault, '*', '*', '*'],
        },
        weekly: {
            options: [
                { index: 4, name: 'day_of_week', values: day_of_week },
                { index: 1, name: 'hour', values: hour },
            ],
            default: [minuteDefault, hourDefault, '*', '*', dayOfWeekDefault],
        },
        monthly: {
            options: [
                { index: 2, name: 'day', values: day },
                { index: 1, name: 'hour', values: hour },
            ],
            default: [minuteDefault, hourDefault, dayDefault, '*', '*'],
        },
    };
};

export const mapSchedulingOptions = (schedulingOptions) => {
    const { day, day_of_week, hour, minute, frequencies } = schedulingOptions;
    if (!frequencies?.length) return null;

    const builders = buildFrequencyCronBuilders({ day, day_of_week, hour, minute });
    const entries = frequencies
        .map(({ id }) => [id, builders[id]])
        .filter(([, builder]) => builder);
    return entries.length ? Object.fromEntries(entries) : null;
};

export const getTypeByCronPattern = (pattern) => {
    const value = pattern.join('-');
    if (/\d+-\d+-\*-\*-\d+/.test(value)) {
        return 'weekly';
    }
    if (/\d+-\d+-\*-\*-\*/.test(value)) {
        return 'daily';
    }
    if (/\d+-\d+-(\d+|L)-\*-\*/.test(value)) {
        return 'monthly';
    }
    return 'daily';
};
